import React from 'react';

const LearningSessionCard = ({
  id,
  updatedAt,
  time_minutes,
  attention_percentage,
  summary,
  teacherId,
  onContinue,
  onDelete
}) => {
  return (
    <div className="bg-white rounded-lg shadow-md p-4 hover:shadow-lg transition-shadow">
      <div className="flex justify-between items-start mb-3">
        <div className="flex-1">
          <p className="text-sm text-gray-500">
            {new Date(updatedAt).toLocaleDateString()} at {new Date(updatedAt).toLocaleTimeString()}
          </p>
          <div className="flex gap-4 mt-2">
            <span className="text-sm">
              <span className="font-semibold">Time:</span> {time_minutes || 0} min
            </span>
            <span className="text-sm">
              <span className="font-semibold">Attention:</span> {attention_percentage || 0}%
            </span>
          </div>
        </div>
        {teacherId && (
          <span className="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded">
            {teacherId.substring(0, 8)}...
          </span>
        )}
      </div>

      {summary && (
        <p className="text-sm text-gray-700 mb-3 line-clamp-2">{summary}</p>
      )}

      <div className="flex gap-2">
        <button
          onClick={() => onContinue && onContinue(id)}
          className="flex-1 px-4 py-2 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-lg hover:from-blue-600 hover:to-purple-700 transition-all font-medium text-sm"
        >
          Continue Session
        </button>
        <button
          onClick={() => onDelete && onDelete(id)}
          className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors font-medium text-sm"
        >
          Delete
        </button>
      </div>
    </div>
  );
};

export default LearningSessionCard;

